export const LANG_ES_DICTIONARY = {};
